import Vue from 'vue';

export default Vue.extend({
  props: ['value'],
  data() {
    return {
      model: this.value
    };
  },
  watch: {
    model: {
      deep: true,
      handler(value) {
        this.$emit('input', value);
      }
    },
    value: {
      deep: true,
      handler(value) {
        this.model = value;
      }
    }
  }
});
